"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Box_1 = __importDefault(require("./Box"));
var Button = react_1.forwardRef(function (props, ref) { return (react_1.default.createElement(Box_1.default, __assign({ ref: ref }, props, { as: "button", variant: "buttons", __css: {
        appearance: 'none',
        alignItems: 'center',
        border: 1,
        borderRadius: 2,
        boxShadow: 'none',
        display: 'inline-flex',
        fontSize: 'm',
        fontWeight: 5,
        height: '2.5em',
        justifyContent: 'center',
        lineHeight: 'large',
        outline: 'none',
        position: 'relative',
        px: '2.5em',
        py: 'calc(.5em - 1px)',
        transition: 'all 0.2s ease-in-out',
        cursor: 'pointer',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        textDecoration: 'none',
        verticalAlign: 'top',
        userSelect: 'none',
        '&[disabled]': {
            opacity: 0.5,
            cursor: 'not-allowed'
        }
    } }))); });
Button.displayName = 'Button';
exports.default = Button;
